import { Component, Inject, OnInit } from "@angular/core";
import { VngDialogRef, VNG_DIALOG_DATA } from "@vengreso/angular-components";
import { DomSanitizer } from "@angular/platform-browser";
import { AddShortcutComponent } from "src/app/vengreso/shortcuts/add-shortcut/add-shortcut.component";
import { LoadingService } from "../../core/core-services/services/loader.service";

@Component({
    selector: "app-video",
    templateUrl: "./video.component.html",
    styleUrls: ["./video.component.scss"],
    standalone: false
})
export class VideoComponent implements OnInit {
  safeURL: any;

  constructor(
    private sanitizer: DomSanitizer,
    @Inject(VNG_DIALOG_DATA) public data: any,
    public dialogRef: VngDialogRef<AddShortcutComponent>,
    private loader: LoadingService
  ) {
    this.safeURL = this.sanitizer.bypassSecurityTrustResourceUrl(this.data.link.video);
  }

  ngOnInit(): void {
    this.loader.start("video-loader");
  }

  myLoadEvent() {
    this.loader.stop("video-loader");
  }

  close(): void {
    this.dialogRef.close();
  }
}
